import { MemberGroups, UserTypes } from "shared-types";
import { getUserGroup } from "../services/authorization";

export function checkIsYp(userType?: UserTypes) {
  return userType
    ? userType === UserTypes.youngPerformerFemale ||
        userType === UserTypes.youngPerformerMale
    : getUserGroup() === MemberGroups.yPerformer;
}
